import { apiService } from '@/shared/services/apiServices';
import { TASK_FORM_ERROR_MESSAGES } from '../errors/errorMessages';
import type {
  ListSubmittedFormsInput,
  ListSubmittedFormsResponse,
} from '../types';
import taskFormEndpoints from './taskFormEndpoints';

export interface ListSubmittedFormsResult {
  success: boolean;
  data?: ListSubmittedFormsResponse;
  error?: string;
}

export async function listSubmittedForms(
  input: ListSubmittedFormsInput
): Promise<ListSubmittedFormsResult> {
  try {
    const params = new URLSearchParams();
    params.set('page', String(input.page));
    params.set('limit', String(input.limit));
    if (input.search) {
      params.set('search', input.search);
    }
    if (input.startDate) {
      params.set('start_date', input.startDate);
    }
    if (input.endDate) {
      params.set('end_date', input.endDate);
    }

    const url = `${taskFormEndpoints.SUBMITTED_FORMS}?${params.toString()}`;
    const result = await apiService.getAPI(url);

    if (!result.error && result.data) {
      return { success: true, data: result.data as ListSubmittedFormsResponse };
    }

    if (result.isNetworkError) {
      return { success: false, error: TASK_FORM_ERROR_MESSAGES.NETWORK_ERROR };
    }

    return { success: false, error: TASK_FORM_ERROR_MESSAGES.DEFAULT_ERROR };
  } catch {
    return { success: false, error: TASK_FORM_ERROR_MESSAGES.UNEXPECTED_ERROR };
  }
}
